import React, { useState, useEffect, useContext } from "react";
import api, { WEB_BASE_URL } from './../../utils/api';
import moment from "moment";
import { Button } from 'react-bootstrap';
import _ from "lodash";
import { AppContext } from "../context/ContextProvider";
import { numberFormat } from './../../utils/functions';
import BookingModal from "./BookingModal";
import BookingRoomFlexibleModal from "./BookingRoomFlexibleModal";
import ReactGA from 'react-ga4';
import SelectDateConfirmModal from "./SelectDateConfirmModal";
import { useTranslation } from 'react-i18next'
import { transformFieldWithLang } from '../../utils/functions';

const BookingPriceSummary = ({ showWith360 = false, forceShowBookingModal = false, is_close_all = false, is_flex = false }) => {
  const { bookStartDate, bookEndDate, bookingData, roomSelected, currentHotel, handleSetBookingCartData, getBookingCartData } = useContext(AppContext);
  const [showBookingModal, setShowBookingModal] = useState(false)
  const [showBookingFlexibleModal, setShowBookingFlexibleModal] = useState(false)

  const isBooked = !!bookStartDate && !!bookEndDate && !!bookingData?.length
  const a = moment(new Date(moment(bookEndDate).format('YYYY-MM-DD')));
  const b = moment(new Date(moment(bookStartDate).format('YYYY-MM-DD')));
  const dayQty = a.diff(b, 'days') || 0

  const totalPrice = _.sumBy(bookingData, (o) => Number(o.price || 0))
  const bookDataJson = !!bookingData?.length ? JSON.stringify(bookingData) : null
  const bookUrl = `${WEB_BASE_URL}/once/${roomSelected?.id}?s_date=${moment(bookStartDate).format('YYYY-MM-DD')}&e_date=${moment(bookEndDate).format('YYYY-MM-DD')}&book_data=${bookDataJson}`

  const bookingCartData = getBookingCartData();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const { t, i18n } = useTranslation()
  const lang = i18n.language || 'th'

  useEffect(() => {
    if (forceShowBookingModal) {
      setTimeout(() => {
        if (is_flex) {
          setShowBookingFlexibleModal(true)
        } else {
          setShowBookingModal(true)
        }
      }, [600])
    }
  }, [forceShowBookingModal])

  const addToCart = (_dateType = 'selected') => {
    let cartItems = bookingCartData?.cart_items || [];

    if (cartItems.length > 0) {
      // check same room_id
      const existingIndex = cartItems.findIndex(item => item.id === roomSelected?.id);

      if (existingIndex > -1) {
        // update existing item
        cartItems[existingIndex] = {
          ...roomSelected,
          booking_items: bookingData,
        };

      } else {
        cartItems.push({
          ...roomSelected,
          booking_items: bookingData,
        });
      }
    } else {
      cartItems = [{
        ...roomSelected,
        booking_items: bookingData,
      }];
    }

    const newBookingCartData = {
      ...bookingCartData,
      start_date: _dateType === 'selected' ? bookStartDate : bookingCartData?.start_date,
      end_date: _dateType === 'selected' ? bookEndDate : bookingCartData?.end_date,
      cart_items: cartItems,
    }
    handleSetBookingCartData(newBookingCartData);

    setTimeout(() => {
      window.location.href = "/once/booking-cart"
    }, 300)
  }

  const externalTextForCopy = transformFieldWithLang(currentHotel?.external_text_for_copy, lang);

  return (
    <>
      <div className={`${showWith360 ? 'p-1' : 'p-3'} text-end ${(showBookingModal || showBookingFlexibleModal) ? 'd-none' : 'd-block'}`} style={{ width: '100%', backgroundColor: '#FFFFFF', borderTop: '1px solid #000000', zIndex: 999, bottom: 0, position: 'sticky', top: 0 }}>
        {!!isBooked && <div className={`d-flex  ${showWith360 ? 'px-3' : ''}`}>
          <div className="text-start" style={{ flex: 1 }}>
            <div><small>{moment(bookStartDate).format('DD/MM/YYYY')} - {moment(bookEndDate).format('DD/MM/YYYY')} ({dayQty} {t('nights')})</small></div>
            <div style={{ color: '#000000', fontSize: 20 }}>฿{numberFormat(totalPrice, true)}</div>
          </div>
          {!!showWith360 && <a className={`py-2 px-5 btn-sm rounded`} style={{ backgroundColor: '#000000', border: 0, borderRadius: 0, color: '#FFFFFF' }}
            href={bookUrl} target="_blank" onClick={() => {
              ReactGA.event({
                category: "BookingProcess",
                action: `${currentHotel?.code}_${roomSelected?.room_no}_360_booking_click`,
                label: `Check Calendar From 360 - ${currentHotel?.name_th} : ${roomSelected?.name_th}`,
              });
            }}>
            {t('booking')}
          </a>}
          {!showWith360 && <Button
            onClick={() => {
              ReactGA.event({
                category: "BookingProcess",
                action: `${currentHotel?.code}_${roomSelected?.room_no || 'closeall'}_ft_booking_click`,
                label: `Click for Open Booking Modal - ${currentHotel?.name_th} : ${roomSelected?.name_th || 'closeall'}`,
              });

              if (is_flex) {
                setShowBookingFlexibleModal(true)
              } else if (is_close_all) {
                setShowBookingModal(true)
              } else {
                if (bookingCartData?.cart_items && bookingCartData?.cart_items?.length > 0 && (
                  (moment(bookingCartData?.start_date).format('YYYY-MM-DD') !== moment(bookStartDate).format('YYYY-MM-DD') ||
                    moment(bookingCartData?.end_date).format('YYYY-MM-DD') !== moment(bookEndDate).format('YYYY-MM-DD'))
                )) {
                  setShowConfirmModal(true);
                } else {
                  addToCart('selected');
                }
                // setShowBookingModal(true)
              }
            }} className={`py-3 px-5 rounded`} style={{ backgroundColor: '#000000', border: 0, borderRadius: 0 }}>
            {is_flex || is_close_all ? (t('book_now')).toUpperCase() : (t('add_to_cart')).toUpperCase()}
          </Button>}
        </div>}

        {(currentHotel?.id && (!currentHotel?.hide_booking_process) && !isBooked) && <div className={`d-flex align-items-center ${showWith360 ? 'px-3' : ''}`} style={{ height: showWith360 ? 52 : 56 }}>
          <div className="text-start text-danger" style={{ flex: 1 }}>
            {t('please_select_date_on_calendar')}
          </div>
          <Button className={`rounded ${showWith360 ? 'py-1' : 'py-3'} px-5 ${showWith360 ? 'btn-sm' : ''}`} disabled style={{ backgroundColor: 'gray', border: 0, height: showWith360 ? 52 : 'auto' }}>
            {is_flex || is_close_all ? (t('book_now')).toUpperCase() : (t('add_to_cart')).toUpperCase()}
          </Button>
        </div>}
        {(currentHotel?.id && !!currentHotel?.hide_booking_process && !isBooked) && <div className={`d-flex align-items-center`} style={{ height: 56 }}>
          <div className="text-start text-danger" style={{ flex: 1 }}>
            {!!externalTextForCopy && <div style={{ cursor: 'pointer' }} onClick={() => {
              navigator.clipboard.writeText(externalTextForCopy)
            }}> {externalTextForCopy} <span className="text-muted">({t('click_to_copy')})</span></div>}
          </div>
          <a className={`rounded py-3 px-5`} style={{ backgroundColor: '#000000', border: 0, borderRadius: 0, color: '#FFFFFF' }} href={currentHotel?.external_booking_link} target="_blank" onClick={() => {
            ReactGA.event({
              category: "BookingProcess",
              action: `${currentHotel?.code}_${roomSelected?.room_no || 'closeall'}_ft_booking_click`,
              label: `Open External Link - ${currentHotel?.name_th} : ${roomSelected?.name_th || 'closeall'}`,
            });
          }}>
            {t('book_now').toUpperCase()}
          </a>
        </div>}
      </div>
      <BookingModal
        show={showBookingModal}
        onHide={(_ignore_reload) => {
          setShowBookingModal(false)
          if (!_ignore_reload) {
            window.location.reload()
          }
        }}
        is_close_all={is_close_all}
      />
      <BookingRoomFlexibleModal
        show={showBookingFlexibleModal}
        onHide={(_ignore_reload) => {
          setShowBookingFlexibleModal(false)
          if (!_ignore_reload) {
            window.location.reload()
          }
        }}
      />
      <SelectDateConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={(dateType) => {
          addToCart(dateType);
        }}
        start_date={bookStartDate}
        end_date={bookEndDate}
      />
    </>
  );
};

export default BookingPriceSummary;
